import axios from 'axios'
import { Buffer } from 'buffer'

export default function useMedia() {
  const supportedMimeType = () => {
    const contentTypes = ['video/webm', 'audio/mp4', 'audio/webm', 'audio/mp3', 'video/mp4']
    const supportedType = contentTypes.find((type) => MediaRecorder.isTypeSupported(type))
    return supportedType
  }

  const createAudioBlob = (audioChunks: BlobPart[]) => {
    const audioBlob = new Blob(audioChunks, { type: supportedMimeType() })
    return audioBlob
  }

  const getBase64 = async (url: string) => {
    const { data } = await axios.get(url, {
      responseType: 'arraybuffer'
    })
    return `data:image/png;base64,${Buffer.from(data, 'binary').toString('base64')}`
  }

  const isDefaultLogo = (url: string) => {
    return url.includes('merchants/media/default_logo.jpg')
  }
  return { supportedMimeType, createAudioBlob, getBase64, isDefaultLogo }
}
